import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'wffilesize'
})
export class FileSizePipe implements PipeTransform {

  transform(size: string, decimals: number = 0): string {
    let fileLength = parseFloat(size);
    if (isNaN(fileLength) || fileLength < 0) {
      return '';
    }

    decimals = decimals || 1;

    if (fileLength >= 1073741824)
      return (fileLength / 1073741824).toPrecision(decimals) + ' GB';

    if (fileLength >= 1048576)
      return (fileLength / 1048576).toPrecision(decimals) + ' MB';

    if (fileLength >= 1024)
      return (fileLength / 1024).toPrecision(decimals) + ' KB';

    return (fileLength) + ' bytes';
  }
}
